import * as React from "react"
import type { SVGProps } from "react"
const SvgTarget = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.43a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.17 10 10 0 0 1-.79-3.9q0-2.08.79-3.9a10 10 0 0 1 2.13-3.18Q6.28 4.01 8.1 3.22a10 10 0 0 1 3.9-.79q.42 0 .71.29.3.29.29.71v7.28q.45.27.73.7.27.45.27 1.02 0 .82-.59 1.41a2 2 0 0 1-1.41.59q-.83 0-1.41-.59a2 2 0 0 1-.59-1.41 1.9 1.9 0 0 1 1-1.72V8.55a4 4 0 0 0-2.15 1.42Q8 11.03 8 12.43q0 1.65 1.18 2.83 1.17 1.17 2.82 1.17c1.65 0 2.04-.4 2.83-1.17A4 4 0 0 0 16 12.43q0-.65-.19-1.2a5 5 0 0 0-.51-1.05 1.2 1.2 0 0 1-.23-.78 1 1 0 0 1 .3-.7q.3-.3.72-.3.41 0 .66.35.58.78.91 1.7.34.93.34 1.98 0 2.5-1.75 4.25A5.8 5.8 0 0 1 12 18.43a5.8 5.8 0 0 1-4.25-1.75A5.8 5.8 0 0 1 6 12.43q0-2.25 1.43-3.91A5.8 5.8 0 0 1 11 6.5V4.48A7.8 7.8 0 0 0 6.01 7.1 7.7 7.7 0 0 0 4 12.43q0 3.35 2.33 5.67A7.7 7.7 0 0 0 12 20.43q3.35 0 5.68-2.33A7.7 7.7 0 0 0 20 12.43q0-1.45-.47-2.74a8 8 0 0 0-1.36-2.34 1 1 0 0 1-.27-.75q0-.42.3-.72a1 1 0 0 1 .71-.29q.41 0 .69.34 1.13 1.32 1.76 2.97t.64 3.53a10 10 0 0 1-.79 3.9 10 10 0 0 1-2.13 3.17q-1.35 1.36-3.18 2.14a10 10 0 0 1-3.9.79" />
  </svg>
)
export default SvgTarget
